import React, { useEffect, useState } from 'react';
import BookImg from '../../Images/img.png'
import DeleteConfirmationModal from '../../Components/DeleteConfirmModal';
import ComplaintModal from '../../Components/ComplaintModal';
import "../../Styles/ConfirmLesson.css"
import { BookOpen, ChevronRight } from 'lucide-react';
import { Card, EmptyState, PageHeader } from '../../Components/ui';
import CourseThumbnail from '../../Components/Courses/CourseThumbnail';
import './MyCourse.css';
import axios from 'axios';
import { MAIN_URL } from '../../constants';
import ConfirmLesson from '../../Components/ConfirmLesson/ConfirmLesson';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../Components/RefreshToken/RefreshToken';

const Courses = () => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [isComplaintModalOpen, setComplaintModalOpen] = useState(false);
    const [courses, setCourses] = useState([]);
    const navigate = useNavigate()
    const TOKEN = localStorage.getItem("admin_token")

    useEffect(() => {
        const getMyCourses = () => {

            api.get(`/management/mentor/my-courses?confirmed=true`, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${TOKEN}`,
                },
            })
                .then((response) => {
                    setCourses(response.data);
                })
                .catch((error) => {
                });
        };

        getMyCourses();
    }, []);


    const handleSelectCourse = (course) => {
        navigate('/course-details', { state: { course } });
    };

    return (
        <div className="ui-mentor-courses">
            <PageHeader title="Mening kurslarim" subtitle="Tasdiqlangan kurslaringiz. Kursni ochib, darslar va testlarni ko'ring." />
            {courses?.length === 0 ? (
                <Card padding="none">
                    <EmptyState
                        icon={<BookOpen />}
                        title="Tasdiqlangan kurslar yo'q"
                        description="Kurs tasdiqlangandan keyin shu yerda ko'rinadi."
                    />
                </Card>
            ) : (
                <div className="ui-mentor-courses__grid">
                    {courses?.map((course, index) => (
                        <div
                            className="ui-mentor-course"
                            key={course.id}
                            onClick={() => handleSelectCourse(course)}
                        >
                            <div className="ui-mentor-course__media">
                                <CourseThumbnail src={course?.photo ? `${MAIN_URL}/${course?.photo}` : ''} className="ui-mentor-course__thumb" />
                                <span className="ui-mentor-course__index">{index + 1}</span>
                            </div>
                            <div className="ui-mentor-course__body">
                                <h3 className="ui-mentor-course__title" title={course.title}>{course.title}</h3>
                                <div className="ui-mentor-course__desc" dangerouslySetInnerHTML={{ __html: course?.description }}></div>
                            </div>
                            <div className="ui-mentor-course__footer">
                                <span>Kursni ochish</span>
                                <ChevronRight aria-hidden="true" />
                            </div>
                            {/* O'chirish tugmasining handler'i yo'q — yashirilgan (known-issues) */}
                            <div className="delete-icon-wrapper" hidden onClick={(e) => e.stopPropagation()}>
                                <i className="ri-delete-bin-fill"></i>
                            </div>
                        </div>
                    ))}
                </div>
            )}


            <DeleteConfirmationModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={() => setModalOpen(false)}
            >
                <p className='confirm-message'>Are you sure to delete the lesson?</p>
            </DeleteConfirmationModal>
            <ComplaintModal
                isOpen={isComplaintModalOpen}
                onClose={() => setComplaintModalOpen(false)}
                onConfirm={() => setComplaintModalOpen(false)}
            >
                <div>
                    <p>Write a text</p>
                    <textarea
                        name="complaintText"
                        id=""
                        cols="30"
                        rows="10"
                        placeholder='Your text here'
                        className='complaint-textarea'
                    >
                    </textarea>
                </div>
            </ComplaintModal>
        </div>
    );
}

export default Courses;
